import { Controller } from 'stimulus'

export default class extends Controller {
  connect() {
    if (!this.bannerId()) {
      return
    }

    if (this.isDismissedInStorage()) {
      this.hideBanner()
    }
  }

  dismiss(event) {
    event.preventDefault()
    event.stopPropagation()

    this.saveDismissalInStorage()

    this.hideBanner()

    if (this.signedIn()) {
      this.persistDismissal()
      return
    }
  }

  hideBanner() {
    this.element.remove()

    this.updateTopBannerOffset()

    const wrapper = document.querySelector(this.contentWrapperSelector())
    if (wrapper) {
      wrapper.classList.remove('with-announcement-banner')
    }
  }

  updateTopBannerOffset() {
    const body = document.body
    if (!body) {
      return
    }

    const rawOffset = window
      .getComputedStyle(body)
      .getPropertyValue('--top-banner-offset')
      .trim()

    const currentOffset = Number.parseInt(rawOffset, 10)
    if (Number.isNaN(currentOffset)) {
      return
    }

    const nextOffset = Math.max(0, currentOffset - 40)
    body.style.setProperty('--top-banner-offset', `${nextOffset}px`)
  }

  persistDismissal() {
    if (!this.dismissUrl() || !this.bannerId()) {
      return
    }

    fetch(this.dismissUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.csrfToken(),
      },
      body: JSON.stringify({ banner_id: this.bannerId() }),
      credentials: 'same-origin',
    }).catch((error) => {
      console.error('Failed to persist banner dismissal:', error)
    })
  }

  csrfToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.content : ''
  }

  isDismissedInStorage() {
    const bannerId = this.bannerId()
    if (!bannerId) {
      return false
    }

    try {
      return this.dismissedIds().includes(bannerId)
    } catch {
      return false
    }
  }

  saveDismissalInStorage() {
    const bannerId = this.bannerId()
    if (!bannerId) {
      return
    }

    try {
      const dismissedIds = this.dismissedIds()
      if (!dismissedIds.includes(bannerId)) {
        dismissedIds.push(bannerId)
      }
      window.localStorage.setItem(
        this.dismissedStorageKey(),
        JSON.stringify(dismissedIds),
      )
    } catch {
      return
    }
  }

  dismissedIds() {
    const raw = window.localStorage.getItem(this.dismissedStorageKey())
    if (!raw) {
      return []
    }

    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      return []
    }

    return parsed.map(String)
  }

  dismissedStorageKey() {
    return 'dismissed-announcement-banner-ids'
  }

  bannerId() {
    return this.data.get('bannerId')
  }

  dismissUrl() {
    return this.data.get('dismissUrl')
  }

  signedIn() {
    return this.data.get('signedIn') === 'true'
  }

  contentWrapperSelector() {
    return this.data.get('contentWrapperSelector') || ''
  }
}
